import PropTypes from 'prop-types';
import React from 'react';
import Navigation from './Navigation';
import Slide from './Slide';
import * as DatabaseUtils from '../utilities/db';
import * as EventUtils from '../utilities/events';
import * as NavigationUtils from '../utilities/navigation';
import { updateUserContact } from '../utilities/results';
import * as ScoringUtils from '../utilities/scoring';
import * as StorageUtils from '../utilities/storage';

class App extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loaded: false,

			// Could be overwritten by data from session storage
			...this.getInitialState(),
		};

		// Bind imported functions
		this.handleChange = EventUtils.handleChange.bind(this);
		this.handleSliderChange = EventUtils.handleSliderChange.bind(this);
		this.afterChangeHandled = EventUtils.afterChangeHandled.bind(this);

		this.goToExactSlide = NavigationUtils.goToExactSlide.bind(this);
		this.goToPrevSlide = NavigationUtils.goToPrevSlide.bind(this);
		this.goToNextSlide = NavigationUtils.goToNextSlide.bind(this);
		this.onSlideChange = NavigationUtils.onSlideChange.bind(this);
		this.restartSurvey = NavigationUtils.restartSurvey.bind(this);

		this.getQuestionScore = ScoringUtils.getQuestionScore.bind(this);
		this.calcUserScore = ScoringUtils.calcUserScore.bind(this);
		this.calcDimensionScore = ScoringUtils.calcDimensionScore.bind(this);
		this.calcTotalScore = ScoringUtils.calcTotalScore.bind(this);

		this.generateUID = StorageUtils.generateUID.bind(this);
		this.trackUser = StorageUtils.trackUser.bind(this);
		this.getSessionData = StorageUtils.getSessionData.bind(this);
		this.getStorageFormKey = StorageUtils.getStorageFormKey.bind(this);
		this.updateSessionData = StorageUtils.updateSessionData.bind(this);

		this.updateUserContact = updateUserContact.bind(this);

		this.dbPushData = DatabaseUtils.dbPushData.bind(this);
	}

	getInitialState = () => {
		return {
			position: 0,
			userData: {
				dimensions: {},
				score: false,
				progress: 0,
			},
		};
	};

	componentDidMount() {
		// Fetch form data from REST API
		this.fetchPostData();

		// Generate user ID
		this.generateUID();
	}

	componentDidUpdate() {
		if (this.state.loaded) {
			// Update session storage to possibly restore the current state
			this.updateSessionData();
		}
	}

	fetchPostData = () => {
		fetch(this.props.api)
			.then((response) => response.json())
			.then((json) => {
				if (json) {
					// Update state in two steps
					// 1. Push form data
					this.setState(json, () => {
						// 2. Fetch user data from session storage
						this.setState({
							...this.getSessionData(),
							loaded: true,
						});
					});
				} else {
					console.error(json);
				}
			});
	};

	render() {
		const state = this.state;
		if (state.loaded) {
			const slide = state.slides[state.position];
			const progress = 'progress' in slide ? slide.progress : false;

			let userInput = false;
			if (slide.type === 'question') {
				const d = slide.dimension;
				userInput = state.userData.dimensions[d]?.results?.[slide.ID] ? state.userData.dimensions[d].results[slide.ID].answers : false;
			}

			return (
				<div className="ms-form">
					<Slide
						updateUserContact={this.updateUserContact}
						contacts={state.contacts}
						dimensions={state.dimensions}
						userData={state.userData}
						userInput={userInput}
						slide={slide}
						labels={this.state.labels}
						handleChange={this.handleChange}
						handleSliderChange={this.handleSliderChange}
						slides={state.slides}
					/>
					<Navigation
						resultsSlide={state.slides.indexOf(state.slides.filter((slide) => slide.type === 'results')[0])}
						slide={slide}
						position={state.position}
						slideCount={Object.keys(state.slides).length}
						dimensions={state.dimensions}
						progress={progress}
						labels={this.state.labels}
						restartBtnCallback={this.restartSurvey}
						prevBtnCallback={this.goToPrevSlide}
						nextBtnCallback={this.goToNextSlide}
						goToSlideCallback={this.goToExactSlide}
						userData={state.userData}
					/>
				</div>
			);
		} else {
			return null;
		}
	}
}

export default App;

App.propTypes = {
	api: PropTypes.string,
};
